import axios from 'axios';
import { Toast } from 'vant';

const server = axios.create();
server.interceptors.request.use(handleRequest, handleError);
server.interceptors.response.use(handleResponse, handleError);

function handleRequest(config) {
  const authToken = window.localStorage.getItem('authToken');
  if (authToken) {
    config.headers.authToken = authToken;
  }
  return config;
}

function handleResponse(response) {
  const head = response.data.head;
  const success = head && head.returnCode !== '-1';
  const message = head && head.returnMessage;
  return success ? response : handleError(new Error(message));
}

function handleError(error) {
  Toast({ message: error.message || '网络繁忙' });
  return Promise.reject(error);
}

export default server;
